import { createFileRoute } from '@tanstack/react-router';

import { NegotiationSolutionManagerPage } from '@/areas/solution-manager/SolutionManager/NegotiationSolutionManagerPage/NegotiationSolutionManagerPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId',
)({
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <NegotiationSolutionManagerPage {...pathParams} />;
}
